import React from 'react';
import PortfolioHeader from './headerPortfolio';
import { motion } from 'framer-motion';

import '../style/main.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const duration = 1;

const variants = {
  initial: {
    opacity: 0,
  },
  enter: {
    opacity: 1,
    transition: {
      duration: duration,
      delay: duration,
      when: 'beforeChildren',
    },
  },
};

const LayoutPortfolio = ({children, siteTitle}) => (
    <>
        <PortfolioHeader siteTitle={siteTitle}/>
        <motion.main
          variants={variants}
          initial="initial"
          animate="enter"  
        >
              {children}
        </motion.main>
    </>
);

export default LayoutPortfolio;
